import { Component, effect, inject, input, signal } from "@angular/core";
import { MessageService } from "../../../services/messageservice";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "filter-bar",
  templateUrl: "filter-bar.html",
  styleUrls: ["filter-bar.scss"],
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
})
export class FilterBar {
  private msgsrv = inject(MessageService);

  readonly filterTitle = input.required<string>();
  readonly filterClassActive = input.required<string>();
  readonly filterType = input.required<string>();
  readonly filterValue = input.required<string>();
  readonly filterDefaultActive = input.required<boolean>();
  readonly filterIcon = input("");
  readonly filterColor = input("");

  protected filterBarActive = signal(false);

  constructor() {
    effect(() => {
      this.filterBarActive.set(this.filterDefaultActive());
    });

    effect(() => {
      const msg = { type: this.filterType(), value: this.filterValue() };

      if (this.filterBarActive()) {
        this.msgsrv.enableFilter(msg);
      } else {
        this.msgsrv.disableFilter(msg);
      }
    });
  }

  toggleFilter = () => this.filterBarActive.update((value) => !value);

  reset() {
    this.filterBarActive.set(this.filterDefaultActive());
  }
}
